import httpClient from '../base/httpClient';

interface AvailabilityRequestPayload {
  userName: string;
  userEmail: string;
  userWhatsApp: string;
  description?: string | null;
  eventDate: string;
  invites: number;
  hasAirConditioner?: boolean | null;
  hasBuffet?: boolean | null;
  hasParking?: boolean | null;
  hasOutdoor?: boolean | null;
  hasSound?: boolean | null;
  hasRoom?: boolean | null;
  places: number[];
  eventTypeId?: number | null;
}

export const AvailabilityRequestAPI = {
  submit: async (data: AvailabilityRequestPayload) => {
    const response = await httpClient.post('/order/create-user-order', data, { skipAuth: true });
    return response.data;
  },
};
